import { Injectable } from '@angular/core';
import { SecurityEvent } from './types/security-event.type';
import { DateTime } from 'luxon';

@Injectable({
  providedIn: 'root',
})
export class SecurityEventsService {
  sendEvent(type: SecurityEvent['eventType'], data?: SecurityEvent['data']): void {
    const securityEvent: SecurityEvent = {
      eventType: type,
      eventId: this.generateUuid(),
      eventDate: DateTime.utc().toISO(),
      url: location.href,
      data: {
        ...data,
      },
    };

    this.send(securityEvent);
  }

  private send(event: SecurityEvent): void {
    const url = '/logs/create-user-security-event';
    const eventJson = JSON.stringify(event);

    navigator.sendBeacon(url, eventJson);
    fetch(url, {
      method: 'POST',
      keepalive: true,
      body: eventJson,
      headers: {
        'content-type': 'application/json',
      },
    });
  }

  private generateUuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
      const random = crypto.getRandomValues(new Uint8Array(1))[0] & 15;
      const value = char === 'x' ? random : (random & 0x3) | 0x8;

      return value.toString(16);
    });
  }
}
